import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './fetnetPortal.json';

const getPersonal = (req, res, ctx) => {
  const responseData = apiResponses['fetnet_portal/v1/personal'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const checkLogin = (req, res, ctx) => {
  const responseData = apiResponses['fetnet_portal/login/check'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData, true, null)));
};

const getHeaderFooter = (req, res, ctx) => {
  const responseData = apiResponses['https://www.fetnet.net/bin/cbu/headerfooter'].success.default;
  return res(ctx.status(200), ctx.json(responseData));
};

export const handlers = [

  rest.post(getApiEndpoint('fetnet_portal/v1/personal'), withScenario(withAuthCheck(getPersonal))),
  rest.get('/fetnet_portal/login/check', withScenario(checkLogin)),
  rest.get('/bin/cbu/headerfooter', withScenario(getHeaderFooter)),
];
